import { lazy } from 'react';

export const CourseViewPage = lazy(() =>
  import('./course-view-page').then(({ CourseViewPage }) => ({
    default: CourseViewPage,
  }))
);
